import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js"
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as api from "../../api/apiConnector.js";
import StringListEditor from '../../components/stringListEditor.js';
import * as utils from "../../components/utils.js";
import { FileFolderSelector } from '../../components/fileFolderSelector.js';
import IconSelector from '../../components/Icon_Selector.js';
import IconFolder from '../../assets/icon/mimetype/icons8-folder.svg'
import folderSearch from '../../assets/icon/folder-search.svg'
import { dms_style } from "../../styles/style.js";
import * as icons from "../../components/fileTypesIcons.js";
import * as uploadManager from "../../components/ui/fileupload.js";
import cloud_icon from "../../assets/images/cloud.svg";
import { useTranslation } from 'react-i18next';


const Requirements_Evaluation_Screen = (params) => {
    const { t } = useTranslation();

    const { currentUser } = useContext(UserContext);
    const [requirement, setRequirement] = useState(null);
    const { requirementId, organizationalUnitId = null } = useParams();
    const [linkData, setLinkData] = useState(null);
    const [valueData, setValueData] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [toSave, setToSave] = useState(false);
    let system_message_timer = null;


    const _tosave = () => {
        setToSave(true);
    }

    useEffect(() => {
        _resizeTable();
        window.$(window).off("resize");
        window.$(window).on("resize", (e) => {
            _resizeTable();
        });

        (async () => {
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();

        })();
    }, []);

    const _resizeTable = () => {
        const _height = window.$(window).height();
        const _responsive = window.$(".table-responsive");
        _responsive.css("height", _height - 120);
    }

    useEffect(() => {
        if (linkData) {
            _drawLinkTabs();
        }

    }, [linkData]);

    useEffect(() => {
        if (valueData) {
            _drawValueTabs();
        }
    }, [valueData]);

    useEffect(() => {
        if (fileData) {
            if (!window.$.fn.dataTable.isDataTable('.file-req-table')) {
                window.$(".file-req-table").DataTable({
                    paging: false,
                    searching: false,
                });
            }
            else {
                // resyncTableSource();
            }
        }
        window.$(".dataTables_empty").hide();
    }, [fileData]);



    const show_system_message = (params) => {
        const { message, timeOut = 2000 } = params;

        const inner_div = window.$(`<div class="col-xl-12">
            <div class="card dz-card">
                <div class="card-header flex-wrap border-0">
                    <div>
                        <h4 class="card-title">{t('aiPlan', { ns: 'labels' })}</h4>
                    </div>											
                </div>
                <div class="tab-content">
                    <div class="tab-pane fade active show" role="tabpanel">
                        <div class="card-body pt-0">
                            <h6><span></span>
                                <span class="pull-end"></span>
                            </h6>                                                                        
                        </div>
                    </div>
                </div>
    
            </div>
        </div>`);

        let div = window.$("#chat-system-message");

        if (div.length == 0) {
            div = window.$(`<div id="chat-system-message" style="position: fixed; right: 20px; bottom: 30px; width: 350px; height: 100px; opacity: 0.75"></div>`);
            window.$("body").append(div);
            div.append(inner_div);
        }

        const message_div = div.find(".pull-end");


        message_div.html("");
        message_div.append(window.$("<div/>").html(message));

        if (system_message_timer) {
            clearTimeout(system_message_timer);
        }

        if (timeOut > 0) {
            system_message_timer = setTimeout(() => {
                div.remove();
            }, timeOut);
        }
    }

    const retrieveData = async () => {
        const result = (await api.sendMessage("admin/requirements/get_all", {
            user: currentUser(),
            body: {
                requirementId: requirementId
            }
        })).requirements[0];


        const evaluationData = await api.sendMessage("requirements/evaluation/get", {
            user: currentUser(),
            body: {
                requirementId: requirementId
            }
        });

        setRequirement(result);


        setLinkData(evaluationData.links);
        setFileData(evaluationData.files);
        setValueData(evaluationData.values);
    }


    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t('home', { ns: 'labels' })
        },
        {
            link: "/Requirements",
            name: t('requirements', { ns: 'labels' })
        }
        ];
        breadcrumb.set(path);
    }


    const _getAllFileInFolder = async (parentId) => {

        var result = await api.sendMessage("dms/retrieveAllFile", {
            user: currentUser(),
            body: {
                parentId: parentId
            }
        });

        return result.files;
    }

    const addItem = async (f, type) => {


        if (type == "folder") {
            let filesToAdd = [];

            var allFile = await _getAllFileInFolder(f.Id);


            if (allFile.length > 0) {
                fileData.push(...allFile);
                return { addedd: allFile }
            }
            else { return null }

        } else if (type == "file") {
            fileData.push(f);
            return { addedd: f }
        }
        else { return null }

    }



    const _drawLinkTabs = () => {
        return (<>
            <div class="col-lg-12 mb-3">
                <p class="fs-14">Here you can add the link that will be evaluated for this requirement</p>

                <StringListEditor data={linkData} columnName="Your links" dataType="string" dfuValue="" onChange={(e) => {
                    setLinkData(utils.clone(e));
                    _tosave();
                }}></StringListEditor>

            </div>
        </>)

    }
    const _drawFileTabs = () => {
        return (<>
            <div class="col-lg-12 mb-3 row ">
                <h6 class="col-md-12">Here you can add or search the link that will be evaluated for this requirement
                    <img src={folderSearch} class='ms-2' title={t('openSearchFiles', { ns: 'labels' })} style={{ cursor: "pointer" }} onClick={(e) => {
                        selectFileModal();
                    }}></img>
                </h6>
                {/* <button type="button" onClick={(e) => {
                    selectFileModal();
                }}
                    className="btn btn-primary col-md-3">Search in your DMS</button> */}
                {_drawFileTables()}
            </div>
        </>)

    }


    const selectFileModal = async (params) => {

        let _modal = window.$(`<div id="select-file-modal" class="modal modal-xl" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{t('chooseYourFile', { ns: 'labels' })}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Modal body text goes here.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    
      </div>
    </div>
  </div>
</div>`);

        window.$("#select-file").remove();
        window.$("body").append(_modal);
        _modal.modal("show");
        const modal_body = _modal.find(".modal-body");

        FileFolderSelector({
            user: currentUser(),
            container: modal_body,
            drawFinder: true,
            onClick: async (f, type) => {
                show_system_message({
                    timeOut: 0,
                    message: `
                    <strong>Adding ${f.Name}</strong>...
                    `});

                var result = await addItem(f, type);

                if (result.addedd) {
                    show_system_message({
                        timeOut: 1500,
                        message: `
                        <strong>Added ${f.Name}</strong>...
                        `});

                    withReactContent(Swal).fire({
                        title: `Adding file `,
                        icon: "info",
                        text: `Adding file ${f.Name} to this evaluation`,
                        allowOutsideClick: false,
                        timer: 1000
                    });

                    setFileData(utils.clone(fileData));
                    _tosave();
                }
                else {
                    show_system_message({
                        timeOut: 1500,
                        message: `
                        <strong>Problem adding  ${f.Name}</strong>...
                        `});

                }

            }
        });
    }

    const normItem = (item) => {
        if (item.ItemLastUpdated) item.ItemLastUpdated = new Date(item.ItemLastUpdated);
        if (item.ItemCreated) item.ItemCreated = new Date(item.ItemCreated);
        if (item.ItemDeleted) item.ItemDeleted = new Date(item.ItemDeleted);
    }

    const getItems = () => {


        let _files = fileData.map((i) => {
            normItem(i);

            return {
                type: "file",
                item: i
            }
        });

        let _output = [];

        for (var i of _files) {
            _output.push(i);
        }

        return _output;
    }

    const getName = (item) => {
        const getPath = () => {
            if (item.item?.Path?.Path) {
                if (item.item?.Path?.Path.length > 0) {
                    return (<><small>in </small>
                        <a href={`/dms/${item.item.Path.Path[item.item.Path.Path.length - 1].Id}`}>
                            {(item.item.Path.Path.map(x => {
                                if (item.item.Path.Path.findIndex(y => y == x) == 0) {
                                    return (<small>{x.Name}</small>);
                                } else {
                                    return (<><small> / </small><small>{x.Name}</small></>);
                                }
                            }))}</a>
                    </>);
                }
            }
        }

        if (item.type === "folder") {
            return (<h6 style={{
                opacity: item.item.System_Item ? .5 : 1
            }}>
                <img width="28" height="28" src={IconFolder} alt='folder' />
                {item.item.Name}</h6>);
        }
        else {
            return (<>
                <h6>
                    <IconSelector icon={item.item.MimeType} />
                    {item.item.Name}</h6>
                {getPath()}
            </>);
        }
    }
    const getItemSize = (item) => {
        if (item.type === "folder") {

        } else {
            if (item.item.FileSize < 1024) {
                return `${item.item.FileSize} bytes`;
            } else if (item.item.FileSize >= 1024 && item.item.FileSize < 1048576) {
                const kbValue = item.item.FileSize / 1024;
                return `${Math.round(kbValue.toFixed(2).toLocaleString())} KB`;
            } else if (item.item.FileSize >= 1048576 && item.item.FileSize < 1073741824) {
                const mbValue = item.item.FileSize / 1024 / 1024;
                return `${Math.round(mbValue.toFixed(2)).toLocaleString()} MB`;
            } else {
                const gbValue = item.item.FileSize / 1024 / 1024 / 1024;
                return `${Math.round(gbValue.toFixed(2)).toLocaleString()} GB`;
            }

        }
    }
    const resyncTableSource = () => {
        //table rows
        var tableRows = window.$(".file-req-table").find(`tr[data-id]`).toArray();

        //table data source
        var tableSource = window.$(".file-req-table").DataTable().rows().data().toArray();

        //sync table versus data
        for (var tr of tableRows) {
            //id of the file or folder to sync
            var idToFind = tr.getAttribute("data-id");

            //datas source item
            var dataSourceItem = tableSource.find(x => window.$(x[0]).attr("data-id") === idToFind);

            //table item (as array of inner html of cells)
            var itemToAdd = window.$(tr).find("td").toArray().map(x => x.innerHTML);

            //is it a new element?
            if (!dataSourceItem) {
                window.$(".file-req-table").DataTable().row.add(itemToAdd);
            } else {
                //todo: must execute a resync
            }
        }
    }

    const getTableRow = (item) => {
        return (<tr key={`file_item.${item.item.Id}`} data-id={item.item.Id} style={{ ...dms_style.table_row }}>

            <td >
                <div data-id={item.item.Id} class="file-name">
                    <div>
                        {getName(item)}

                    </div>
                </div>
            </td>
            <td style={{ cursor: "pointer", textAlign: "center" }}
                onClick={(e) => {

                    show_system_message({
                        timeOut: 0,
                        message: `
                        <strong>Deleting ${item.item.Name} from the list</strong>...
                        `});




                    // if (result.deleted) {
                    show_system_message({
                        timeOut: 1500,
                        message: `
                            <strong> ${item.item.Name} deleted correctly</strong>...
                            `});
                    fileData.splice(fileData.findIndex(x => x.Id === item.item.Id), 1);

                    setFileData(utils.clone(fileData));
                    _tosave();


                }}
            ><i class="fa fa-trash me-2 text-secondary"></i></td>


        </tr>);
    }
    const getTableRows = () => {
        let _items = getItems();
        return _items.map((i) => { return (getTableRow(i)) });
    }



    const _frDraggingEffect = (e, show) => {

        const _path_parts = window.$(".breadcrumb").find("li").toArray();
        const _path = window.$(_path_parts[_path_parts.length - 1]).text();

        const _panel = window.$(`            
            <div id="dragging-bubble" class="bg-primary"             
            style="box-shadow: 2px 2px 2px 1px rgb(0 0 0 / 20%); z-index: 10000; position: fixed; bottom: 20px; transform: translateX(-50%); left: 50%; width: 300px; height: 80px; border-radius: 25px; opacity: .1;">
            <div id="dragging-bubble-icon" style="position: absolute; margin-top: -75px; width: 100%; text-align: center;"><img style="width: 100px" src="${cloud_icon}" /></div>
            <div style="position: relative; left: 0; top: 20px; width: 100%; text-align: center; color: white;">Drop files to upload them to</div>
            <div style="padding: 25px; position: relative; left: 0; top: 10px; width: 100%; text-align: center; color: white; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"><i class="fa fa-folder-tree me-2"></i> ${_path}</div>
        </div>`);

        let _stopSignal = false;
        if (show) {
            if (window.$("#dragging-bubble").length == 0) {
                window.$("body").append(_panel);
                console.log("fr");
                _panel.fadeTo("slow", 1);

                let _direction = "up";

                const _animate = () => {
                    const _icon = window.$("#dragging-bubble-icon");
                    if (_direction == "up") {
                        _icon.animate({ "top": "-=25px" }, "slow", () => {
                            _direction = "down";
                            if (!_stopSignal) _animate();
                        });
                    } else {
                        _icon.animate({ "top": "+=25px" }, "slow", () => {
                            _direction = "up";
                            if (!_stopSignal) _animate();
                        });
                    }
                }

                _animate();
            }


        }
        else {
            _stopSignal = true;

            const _icon = window.$("#dragging-bubble-icon");
            _icon.animate({ "top": "-=1125px" }, "medium", () => {
                window.$("#dragging-bubble").remove();
            });
        }
    }

    const upload = async (params) => {
        params.user = currentUser();
        uploadManager.fileUpload(params);
    }

    const _drawFileTables = () => {




        if (!fileData) {
            return (<div class="text-center"><img src={waiting} /></div>);
        }

        return (
            <>

                <div className="tab-content">
                    <div className="tab-pane fade active show" id="document-list-panel" role="tabpanel" aria-labelledby="document-list-tab" tabindex="0">
                        <div class="container-fluid" onMouseOver={(e) => {
                            window.$("#draggableArea").removeClass("draggableArea");
                            _frDraggingEffect();
                        }}
                            onDragOver={(e) => {
                                window.$("#draggableArea").removeClass("draggableArea");
                                _frDraggingEffect();
                            }}
                        >
                            <div className='draggable-div' id="draggableArea"
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (e.dataTransfer && e.dataTransfer.items
                                        && e.dataTransfer.items.length > 0
                                    ) {

                                        for (const f of e.dataTransfer.items) {
                                            if (f.kind == "file") {
                                                const _icon = icons.iconMapping(f.type);
                                            }
                                        }
                                    }
                                }}
                                onMouseOut={(e) => {
                                    window.$("#draggableArea").removeClass("draggableArea");
                                }}
                                onDragEnter={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.$("#draggableArea").addClass("draggableArea");
                                    _frDraggingEffect(e, true);
                                }}
                                onDragEnd={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.$("#draggableArea").removeClass("draggableArea");
                                }}
                                onDragLeave={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    //  window.$("#draggableArea").removeClass("draggableArea");

                                }}
                                onDrop={async (e) => {
                                    window.$("#draggableArea").removeClass("draggableArea");
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const _files = await uploadManager.getAllFileEntries(e.dataTransfer.items);

                                    //if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
                                    if (_files.files && _files.files.length) {


                                        /*UPLOAD FILES HERE*/
                                        upload({
                                            files: _files.files, parentId: "documents", onFileAdded: (files) => {

                                                // var parentIDPath = content.path[content.path.length - 1].link;
                                                // let realUIDPath = parentIDPath.split("/");

                                                for (var f of files) {

                                                    normItem(f);
                                                    //todo addingFiles
                                                    fileData.push(f);
                                                    setFileData(utils.clone(fileData));
                                                    _tosave();
                                                }

                                            },


                                        });
                                    }
                                }}
                            >
                                <table className="table file-req-table" >

                                    <thead>
                                        <tr>
                                            <th className="col-11">Name</th>
                                            <th className="text-end col-1">Commands</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fileData ? (getTableRows()) : (<div class="text-center"><img src={waiting} /></div>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>);
    }


    const _drawValueTabs = () => {
        return (<>
            <div class="col-lg-12 mb-3">
                <p class="fs-14">Here you can add the value that will be evaluated for this requirement</p>


                <StringListEditor data={valueData} columnName="Your values" dfuValue="" dataType="textarea"
                    onChange={(e) => {
                        setValueData(utils.clone(e));
                        _tosave();
                    }}
                ></StringListEditor>

            </div>
        </>)

    }


    const _drawTabs = () => {
        return (
            <>
                <ul class="nav nav-tabs" id="tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="file-tab" data-bs-toggle="tab" data-bs-target="#file-content" type="button" role="tab" aria-controls="file-content" aria-selected="false">Files</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="value-tab" data-bs-toggle="tab" data-bs-target="#value-content" type="button" role="tab" aria-controls="value-content" aria-selected="false">Values</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="link-tab" data-bs-toggle="tab" data-bs-target="#link-content" type="button" role="tab" aria-controls="link-content" aria-selected="true">Links</button>

                    </li>
                </ul>
                <div class="tab-content" id="tabs-content" style={{ padding: 15 }}>
                    <div class="tab-pane fade active show" id="file-content" role="tabpanel" aria-labelledby="file-tab">
                        {_drawFileTabs()}
                    </div>
                    <div class="tab-pane fade" id="value-content" role="tabpanel" aria-labelledby="value-tab">
                        {_drawValueTabs()}
                    </div>
                    <div class="tab-pane fade" id="link-content" role="tabpanel" aria-labelledby="link-tab">

                        {_drawLinkTabs()}
                    </div>

                </div>
            </>

        )

    }


    const _validate = () => {
        const errors = [];

        if(!toSave){
            var error = `Nothing to save`
            errors.push(error);
        }


        //checking link
        if (linkData.length > 0) {
            let linkDataNullValue = false;

            for (const ld of linkData) {

                if (ld == "") {
                    linkDataNullValue = true;
                }
            }

            if (linkDataNullValue) {
                var error = `There is a empty value in the links`
                errors.push(error);
            }

        }

        //checking value
        if (valueData.length > 0) {
            let valueDataNullValue = false;

            for (const vd of valueData) {

                if (vd == "") {
                    valueDataNullValue = true;
                }
            }

            if (valueDataNullValue) {
                var error = `There is a empty value in the values`
                errors.push(error);
            }

        }

        return errors;

    }

    const _saveEvaluation = async () => {
        let errors = _validate();



        withReactContent(Swal).fire({
            title: t('saving', { ns: 'labels' }),
            icon: "info",
            text: t('saveData', { ns: 'labels' }),
            allowOutsideClick: false
        });

        if (errors.length > 0) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: errors.join(','),
                showConfirmButton: true,

            });
        }
        else {

            const result = await api.sendMessage("requirements/evaluation/save", {
                user: currentUser(),
                body: {
                    requirementId: requirementId,
                    organizationalUnitId: organizationalUnitId,
                    files: fileData,
                    links: linkData,
                    values: valueData
                }

            });

            if (result.message) {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true
                });
            }
            else {
                withReactContent(Swal).fire({
                    title: t('success', { ns: 'labels' }),
                    icon: "success",
                    text: `${result.updated.length} evaluation updated with success`,
                    showConfirmButton: true
                });

                setToSave(false);
            }


        }

    }

    const _drawRequirementArea = () => {

        return (
            <>
                <div className="card-header">
                    <h4 className="heading mb-0">{requirement.Code} - {requirement.Name}</h4>
                </div>
                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-lg-12 mb-3">
                            <h6 className="mb-1 fw-semibold">Notes</h6>
                            <p className="fs-14">{requirement.Notes}</p>
                        </div>


                    </div>

                </div>


                {_drawTabs()}
            </>
        )

    }


    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                </ol>
                <div>


                    <a className="text-primary fs-13" onClick={(e) => {
                        _saveEvaluation();
                    }} role="button" title={t('saveData', { ns: 'labels' })}><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {requirement ? (
                                        <>
                                            {_drawRequirementArea()}
                                        </>) : <div className="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )

}

export { Requirements_Evaluation_Screen }